import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { Subscribable, SubscribableOrNullableValue } from 'knockout';
import './youtube.html';
import './youtube.scss';

components.preload('fancybox-video-iframe-new');

export interface WCCFancyboxYoutubeVMConfig {
    id: SubscribableOrNullableValue<string>
}

@injectable()
export default class WCCFancyboxYoutubeVM {
    src: Subscribable<string | undefined>
    thumbnail: Subscribable<string | undefined>

    isReady: Subscribable<boolean>

    constructor(
        @inject(wccModules.componentConfig) config: WCCFancyboxYoutubeVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo
    ) {
        const id = ko.flattenComputed(config.id);

        this.src = id.pluck(id => `https://www.youtube.com/embed/${id}`);
        this.thumbnail = id.pluck(id => `https://img.youtube.com/vi/${id}/0.jpg`);

        this.isReady = ko.pureComputed(() => id() != undefined);

        ko.applyBindingsToNode(info.element, {
            'visible': this.isReady,

            'css': {
                'wcc-fancybox-youtube': true
            }
        });
    }
}